import '../utils/number-extension';
import Namespace from '@ember/application/namespace';
import Application from '@ember/application';

import ENV from '../config/environment';

import snakeCase from 'lodash.snakecase';
import camelCase from 'lodash.camelcase';

// To help prevent older browsers (IE9, IE10) from crashing
// May not be necessary with the updated browser-detector.
// let originHack = function (locator) {
//     if (!locator.location.origin) {
//         return (
//             locator.location.protocol +
//             '//' +
//             locator.location.hostname +
//             (locator.location.port ? ':' + locator.location.port : '')
//         );
//     } else {
//         return locator.location.origin;
//     }
// };

export default {
    getLtSpiceLocation() {
        return ENV.ltSpiceLocation;
    },

    getConfigData() {
        const configURL = ENV.rootURL.endsWith('/')
            ? `${ENV.rootURL}siteconfig.json`
            : `${ENV.rootURL}/siteconfig.json`;

        const language =
            document && document.documentElement && document.documentElement.lang
                ? document.documentElement.lang
                : 'en';

        return {
            url: configURL,
            language: language,
            rootURL: ENV.rootURL,
        };
    },

    isFunction(functionToCheck) {
        return functionToCheck instanceof Function;
    },

    parseUrl(str) {
        if (typeof str !== 'string') {
            return {};
        }

        str = str.trim().replace(/^(\?|#|&)/, '');

        if (!str) {
            return {};
        }

        return str.split('&').reduce((ret, param) => {
            var parts = param.replace(/\+/g, ' ').split('=');
            var key = parts[0];
            var val = parts[1];

            key = decodeURIComponent(key);

            // missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            val = val === undefined ? null : decodeURIComponent(val);

            if (!(key in ret)) {
                ret[key] = val;
            } else if (Array.isArray(ret[key])) {
                ret[key].push(val);
            } else {
                ret[key] = [ret[key], val];
            }

            return ret;
        }, {});
    },

    stringify(obj) {
        return obj
            ? Object.keys(obj)
                  .sort()
                  .map((key) => {
                      let val = obj[key];

                      if (Array.isArray(val))
                          return val
                              .sort()
                              .map((x) => encodeURI(key) + '=' + encodeURI(x))
                              .join('&');

                      return encodeURI(key) + '=' + encodeURI(val);
                  })
                  .join('&')
            : '';
    },

    loadSvg(svg, container, anonFunc) {
        fetch(`${ENV.svgsLocation}/${svg}`)
            .then((response) => response.text())
            .then((svg) => {
                container.innerHTML = svg;
                if (anonFunc) anonFunc(container);
            });
    },

    isNumeric(value) {
        return !(this.isNullOrWhiteSpace(value) || isNaN(value) || value === true || value === false);
    },

    convertDataTypeFromHash(hashValue) {
        if (typeof hashValue !== 'undefined' && this.isNumeric(hashValue)) {
            return Number(hashValue);
        } else if (typeof hashValue !== 'undefined' && hashValue === 'true') {
            return true;
        } else if (typeof hashValue !== 'undefined' && hashValue === 'false') {
            return false;
        } else {
            return hashValue;
        }
    },

    getNumericRange(value, partialEligible) {
        let base = '1',
            halfBase = '5',
            roundedValue = value.toScale(0),
            valueLength = roundedValue.toString().length,
            halfRange = valueLength > 1 ? Number(halfBase.padEnd(valueLength - 1, '0')) : 0,
            range = Number(base.padEnd(valueLength, '0')),
            halfChar = valueLength > 1 && value.toString().charAt(1),
            // true will round to half, otherwise will round up or down
            halfEligible =
                partialEligible &&
                halfChar &&
                (Math.abs(halfChar - 5) < Math.abs(halfChar - 0) || Math.abs(halfChar - 5) < Math.abs(halfChar - 10));

        return {
            value: range,
            partial: halfEligible ? halfRange : 0,
        };
    },

    isBoolean(value) {
        return typeof value == typeof true || typeof value == typeof false;
    },

    isPrime(value) {
        for (var i = 2; i < value; i++) {
            if (value % i === 0) {
                return false;
            }
        }

        return value > 1;
    },

    closestPrime(value) {
        let i = 0;
        let found = false;
        let possiblePrime;

        value = value.toScale(0, 'trunc');
        if (value < 2) return 2;

        while (!found) {
            possiblePrime = value + i;
            if (this.isPrime(possiblePrime)) {
                found = true;
            }

            i = i + 1;
        }

        return possiblePrime;
    },

    roundTo(value, scale, inFunc) {
        let func = inFunc || 'round';
        return Math[func](value * Math.pow(10, scale)) / Math.pow(10, scale);
    },

    roundToStep(value, step, inFunc) {
        let func = inFunc || 'round',
            inv = 1.0 / step;
        return Math[func](value * inv) / inv;
    },

    disableConsole(disable) {
        if (disable) {
            window.console = {
                error: function () {},
                log: function () {},
                info: function () {},
                warn: function () {},
                group: function () {},
                dir: function () {},
                groupCollapsed: function () {},
                groupEnd: function () {},
                trace: function () {},
                time: function () {},
                timeEnd: function () {},
            };
        }
    },

    getUrlParameter(name) {
        let hashMap = this.parseUrl(top.location.hash);
        return name in hashMap ? hashMap[name] : null;
    },

    isNullOrWhiteSpace: function (text) {
        return typeof text !== 'undefined' ? text === null || text.toString().match(/^\s*$/) !== null : true;
    },

    compare(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    },

    downloadFile(contentType, fileName, fileData) {
        let success = false;
        if (fileData) {
            let blob = new Blob([fileData], { type: contentType });
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                var URL = window.URL || window.webkitURL;
                var downloadUrl = URL.createObjectURL(blob);

                if (fileName) {
                    var a = document.createElement('a');
                    if (typeof a.download === 'undefined') {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                    }
                } else {
                    window.location = downloadUrl;
                }
                setTimeout(function () {
                    URL.revokeObjectURL(downloadUrl);
                }, 100);
            }
            success = true;
        }

        return success;
    },

    formatCell(dataType, value) {
        return `<span class="${dataType}-cell">${value}</span>`;
    },

    getAppContainer() {
        let app = Namespace.NAMESPACES.find((namespace) => namespace instanceof Application);
        if (app) return app.__container__;
        else return {};
    },

    generateNamingMetadata(item) {
        item.appName = snakeCase(item.name);
        item.propertyName = camelCase(item.name);
    },
};
